module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.show,
      "width": "450",
      "mask-closable": false,
      "class-name": "blacklist"
    },
    on: {
      "on-visible-change": _vm.onModalChange
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#ff9100"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('p', {
    staticClass: "message"
  }, [_vm._v("您的公司账户暂无法下单")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("请拨打 021-36622199 或联系专享客服")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onModalChange(false)
      }
    }
  }, [_vm._v("确定")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-13bed680", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13bed680"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/blacklist-modal.vue
// module id = 1349
// module chunks = 61